// import { createListViewProvider } from './list';
import { createActionItemControllerV2 } from './action';
import { ApplicationViewConfig } from './applicationViewConfig';
import { ApplicationController } from './applicationViewInterface';
import { createConfirmTermsController } from './confirm-terms';
import { createConfirmationController } from './confirmation';
import { createListController } from './list/listViewController';
import { createModalV2Controller } from './modal';
import { createSearchV2Controller } from './search-v2';
import { createSelectV2Controller } from './select-v2';

export function createApplicationController(
    config: ApplicationViewConfig = {}
): ApplicationController {
    return {
        // list: createListViewProvider(),
        createList: createListController,
        createSearch: createSearchV2Controller,
        createSelect: createSelectV2Controller,
        createModal: createModalV2Controller,
        createConfirmTermsController: createConfirmTermsController,
        createConfirmationController: createConfirmationController,
        createAction: createActionItemControllerV2,
    };
}
